import React from "react";

const DEFAULT_ORIFICE_SIZES = [
      18, 22, 24, 27, 30, 32, 34, 35, 37, 39, 40, 41, 43, 45, 46, 49, 52, 55, 56, 58, 60, 61, 62, 63, 64, 65, 66, 67,
      68, 70, 72, 73, 74, 75, 76, 78, 79, 80, 82, 83, 85, 86, 87, 88, 90, 91, 92, 94, 95, 96, 97, 98, 100, 102, 103,
      106, 109, 110, 112, 114, 115, 118, 120, 124, 126, 127, 130, 134, 140, 148, 155,
];

const DEFAULT_SWIRL_TYPES = [1, 2, 3, 4, 5, 5.5, 6, 6.5, 7, 8, 9, 10];

const InputsPanel = ({
      unit,
      setUnit,
      noNozzles,
      setNoNozzles,
      pressure,
      currentTab,
      changePressure,
      orificeDiscSize,
      changeOrificeDiscSize,
      showOrificeDiscSizeOptions,
      setShowOrificeDiscSizeOptions,
      swirlType,
      changeSwirlType,
      showSwirlTypeOptions,
      setShowSwirlTypeOptions,
      flowRate,
      changeFlowRate,
      onCalculate,
      orificeDiscOptions = DEFAULT_ORIFICE_SIZES,
      swirlTypeOptions = DEFAULT_SWIRL_TYPES,
}) => {
      return (
            <div className="inputs-panel">
                  {/* 🔹 Metric / Imperial Toggle */}
                  <div className="single-input">
                        <div
                              className={`switch-box ${unit === "metric" && "selected-switch left-switch"}`}
                              onClick={() => setUnit("metric")}
                        >
                              <span>METRIC</span>
                        </div>
                        <div
                              className={`switch-box ${unit === "imperial" && "selected-switch right-switch"}`}
                              onClick={() => setUnit("imperial")}
                        >
                              <span>IMPERIAL</span>
                        </div>
                  </div>

                  {/* 🔹 Number of Nozzles */}
                  <div className="single-input">
                        <span>NUMBER OF NOZZLES</span>
                        <div className="input-number-wrapper">
                              <input
                                    type="number"
                                    className="input-number"
                                    value={noNozzles}
                                    min="1"
                                    max="100"
                                    onChange={(e) => {
                                          const value = parseInt(e.target.value, 10);
                                          if (!isNaN(value) && value >= 1 && value <= 100) {
                                                setNoNozzles(value);
                                          } else if (e.target.value === "") {
                                                setNoNozzles("");
                                          }
                                    }}
                              />
                              <div className="input-number-buttons">
                                    <div
                                          className="input-number-button"
                                          onClick={() =>
                                                noNozzles < 100 && setNoNozzles((prev) => parseInt(prev || 0) + 1)
                                          }
                                    >
                                          <img src="/images/arrow-up.png" alt="Increment" />
                                    </div>
                                    <div
                                          className="input-number-button"
                                          onClick={() =>
                                                noNozzles > 1 && setNoNozzles((prev) => parseInt(prev || 1) - 1)
                                          }
                                    >
                                          <img src="/images/arrow-down.png" alt="Decrement" />
                                    </div>
                              </div>
                        </div>
                  </div>

                  {/* 🔹 Pressure */}
                  <div className="single-input">
                        <span>PRESSURE</span>
                        <input type="text" value={pressure} onChange={(e) => changePressure(e.target.value)} />
                        <div className="unit">
                              <span>{unit === "metric" ? "bar" : "psi"}</span>
                        </div>
                  </div>

                  {currentTab !== "swirl-flow" && currentTab !== "flow-pressure" && (
                        <div className="single-input">
                              <span>ORIFICE DISC SIZE</span>
                              <div className="select-container">
                                    <input
                                          type="text"
                                          value={orificeDiscSize ?? ""}
                                          readOnly
                                          placeholder="Select orifice disc"
                                    />
                                    <div
                                          className={`dropdown-container ${showOrificeDiscSizeOptions ? "open" : ""}`}
                                          onClick={() => {
                                                setShowOrificeDiscSizeOptions(!showOrificeDiscSizeOptions);
                                                setShowSwirlTypeOptions(false);
                                          }}
                                    >
                                          <img src="/images/arrow-down.png" alt="Dropdown" />
                                    </div>
                              </div>
                              <div className={`dropdown-options ${showOrificeDiscSizeOptions ? "show" : ""}`}>
                                    <div className="dropdown-scroll">
                                          {orificeDiscOptions.map((size) => (
                                                <div
                                                      key={size}
                                                      className="option"
                                                      onClick={() => changeOrificeDiscSize(size)}
                                                >
                                                      {size}
                                                </div>
                                          ))}
                                    </div>
                              </div>
                        </div>
                  )}
                  {currentTab !== "wear-parts" && (
                        <div className="single-input">
                              <span>FLOW RATE</span>
                              <input
                                    type="text"
                                    value={flowRate}
                                    onChange={(e) => changeFlowRate(e.target.value)}
                                    placeholder="Enter flow rate"
                              />

                              <div className="unit">
                                    <span>{unit === "metric" ? "L/hr" : "gal/min"}</span>
                              </div>
                        </div>
                  )}

                  {currentTab !== "flow-pressure" && (
                        <div className="single-input">
                              <span>SWIRL TYPE</span>
                              <div className="select-container">
                                    <input
                                          type="text"
                                          value={swirlType ?? ""}
                                          readOnly
                                          placeholder="Select swirl type"
                                    />
                                    <div
                                          className={`dropdown-container ${showSwirlTypeOptions ? "open" : ""}`}
                                          onClick={() => {
                                                setShowSwirlTypeOptions(!showSwirlTypeOptions);
                                                setShowOrificeDiscSizeOptions(false);
                                          }}
                                    >
                                          <img src="/images/arrow-down.png" alt="Dropdown" />
                                    </div>
                              </div>
                              <div className={`dropdown-options ${showSwirlTypeOptions ? "show" : ""}`}>
                                    <div className="dropdown-scroll">
                                          {swirlTypeOptions.map((type) => (
                                                <div
                                                      key={type}
                                                      className="option"
                                                      onClick={() => changeSwirlType(type)}
                                                >
                                                      {type}
                                                </div>
                                          ))}
                                    </div>
                              </div>
                        </div>
                  )}

                  <div className="calculate" onClick={onCalculate}>
                        CALCULATE &gt;&gt;
                  </div>
            </div>
      );
};

export default InputsPanel;
